@use "../styles/variables" as v;

.cnc-page-content {
  background: var(--base-bg-weak-default);
  border-radius: v.$unit;
  padding: v.$unit * 2;
  > .header {
    display: flex;
    flex: 0 0 auto;
    flex-flow: row nowrap;
    .title-section {
      display: flex;
      flex: 1 1 auto;
      min-width: 0;
      flex-flow: column nowrap;
    }
    .action-section {
      display: inline-flex;
      flex: 0 0 auto;
      flex-flow: row nowrap;
    }
  }
  .mds-container {
    margin-top: v.$unit * 2;
  }
}
